import axios from "axios";
import setupInterceptors from "./setupInterceptors";

// Environment değişkeninden API URL'sini al
// Development: http://localhost:7285/api, Production: https://test.menubura.com/api
const API_BASE_URL = process.env.VUE_APP_API_URL || "http://localhost:7285/api";

// Singleton axios instance - interceptor'lar sadece bir kere eklenir
const apiInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Interceptor'ları sadece bir kere ekle
setupInterceptors(apiInstance);

// Interceptor'suz instance - refresh token için kullanılır
// Bu instance 401 aldığında tekrar refresh yapmaya çalışmaz
export const apiWithoutInterceptor = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Default export - her çağrıda aynı instance'ı döndürür
export default () => apiInstance;

